export const CUSTOMER_SUPPORT_SERVICE_STATUS = [
  {
    value: 'pending',
    label: 'Pending',
    color: '#fb8c00'
  },
  {
    value: 'answered',
    label: 'Answered',
    color: '#2196f3'
  },
  {
    value: 'closed without survey',
    label: 'Closed',
    color: '#e0e0e0'
  },
  { value: 'closed with survey', label: 'Closed with survey', color: '#e0e0e0' },
  {
    value: 'cancelled',
    label: 'Cancelled',
    color: '#ff5252'
  },
  {
    value: 'cancelled by customer',
    label: 'Cancelled by customer',
    color: '#fd87ee'
  }
]



// WEBPACK FOOTER //
// ./src/constants/customer-support-service/ticketStatus.js